import { z } from "zod";

import { ImpulseFormUnit } from "~/tools/impulse-form";
import { isStringDirty } from "~/tools/is-string-dirty";

const DEFAULT = "";
const MAX = 200;

const schema = z
	.string()
	.trim()
	.pipe(
		z.union([
			z.literal("").transform(() => undefined),
			z.coerce.number().positive("Must be a positive number").max(MAX, `Must be at most ${MAX}`),
		]),
	);

type WidgetFontSize = ImpulseFormUnit<string, ReadonlyArray<string>, undefined | number>;

function init(initial = DEFAULT): WidgetFontSize {
	return ImpulseFormUnit(initial, {
		isInputDirty: isStringDirty,
		schema,
	});
}

const WidgetFontSize = {
	default: DEFAULT,
	max: MAX,
	init,
} as const;

export { WidgetFontSize };
